import { Link } from "react-router-dom";

export function Logo({ size = "md", light = false }) {
  const s = size === "lg" ? "text-3xl" : size === "sm" ? "text-lg" : "text-2xl";
  return (
    <Link to="/" data-testid="logo-link" className="inline-flex items-center gap-2 group">
      <span className="otelia-dot" />
      <span className={`font-serif ${s} tracking-tight ${light ? "text-canvas" : "text-ink"} group-hover:opacity-80 transition-opacity`}>
        Otelya
      </span>
    </Link>
  );
}
